export function PdfIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M6 11h1v-1H6v1zM12 10h.119a.881.881 0 01.881.881v2.238a.881.881 0 01-.881.881H12v-4z"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4 5a3 3 0 013-3h8a5.002 5.002 0 014.9 4h.1a2 2 0 012 2v8a2 2 0 01-2 2v1a3 3 0 01-3 3H7a3 3 0 01-3-3v-1a2 2 0 01-2-2V8a2 2 0 012-2V5zm11-1c1.306 0 2.418.835 2.83 2H6V5a1 1 0 011-1h8zM6 19v-1h12v1a1 1 0 01-1 1H7a1 1 0 01-1-1zm-2-9a2 2 0 012-2h1a2 2 0 012 2v1a2 2 0 01-2 2H6v2a1 1 0 11-2 0v-5zm7.043-2C10.467 8 10 8.467 10 9.043v5.914c0 .576.467 1.043 1.043 1.043h1.076A2.881 2.881 0 0015 13.119v-2.238A2.88 2.88 0 0012.119 8h-1.076zM18 8a2 2 0 00-2 2v5a1 1 0 102 0v-2a1 1 0 100-2v-1h1a1 1 0 100-2h-1z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
